import { render } from "./DefaultInput.vue?vue&type=template&id=53b806fa"
import script from "./DefaultInput.vue?vue&type=script&lang=ts"
export * from "./DefaultInput.vue?vue&type=script&lang=ts"
script.render = render

export default script